<template>
    <div class="delete-event-form should-dim modify-form bg-gray-50 border rounded-sm border-solid border-gray-300 p-sm">
        <div>
            <template v-if="event.name || event.title">
                Are you sure you want to {{ isAvailability ? 'remove' : 'delete' }} <strong>{{ event.name || event.title }}</strong>?
            </template>
            <template v-else>
                Are you sure you want to delete this event?
            </template>
        </div>
        <div v-if="recurring" class="m-t-sm">
            <p v-if="isAvailability">This slot <strong>repeats weekly</strong>. What would you like to remove?</p>
            <p v-else>This is a <strong>recurring event</strong>. What would you like to delete?</p>
            <div>
                <label>
                    <input type="radio" value="single" id="only_this_event" v-model="recurringPick"> {{ isAvailability ? 'Only this slot' : 'Only this event' }}
                </label>
            </div>
            <div>
                <label>
                    <input type="radio" value="future" id="this_and_following_events" v-model="recurringPick"> {{ isAvailability ? 'This and future repeats of this slot' : 'This and following events' }}
                </label>
            </div>
            <div>
                <label>
                    <input type="radio" value="all" id="all_related_events" v-model="recurringPick"> {{ isAvailability ? 'All upcoming repeats of this slot' : 'All events' }}
                </label>
            </div>
            <p v-if="isAvailability" class="text-12 text-gray-600 m-t-xs m-b-none">
                <i class="fa-solid fa-circle-info m-r-xxs"></i>
                Only repeats of this exact time are removed &mdash; other slots stay put. Slots a family has booked or been invited to are never removed; cancel those from the lesson itself.
            </p>
        </div>
        <div class="flex flex-col justify-space-between gap-sm m-t-md">
            <div class="w-full">
                <ladda-button @lbClicked="deleteEventPressed" el-class="btn-danger w-full" :loading="loading">
                    Yes, Delete
                </ladda-button>
            </div>
            <button v-on:click="hideEventDeleteForm" class="btn btn-default w-full">
                Cancel
            </button>
            <div v-show="error" class="col-span-2">
                <small>
                    <span class="text-danger">{{ errorMessage }}</span>
                </small>
            </div>
        </div>
    </div>
</template>

<script>
import LaddaButton from '../../shared/ladda_button.vue';
import { errorableMix } from './mixins/errorable_mix';

export default {
  name: 'delete-event-form',
  components: { LaddaButton },
  mixins: [errorableMix],
  props: {
    event: {
      type: Object,
      required: true,
    },
    recurring: {
      type: Boolean,
      default: false,
    },
    // 'event' (calendar) or 'availability' (private lesson slots). Availability
    // copy says slot/remove and notes that held slots survive recurring
    // deletes (the API's lesson-aware destroy skips them).
    variant: {
      type: String,
      default: 'event',
    },
  },
  data() {
    return {
      loading: false, // Loading is a network variable (hitting the api)
      recurringPick: 'single',
    };
  },
  computed: {
    isAvailability() {
      return this.variant === 'availability';
    },
  },
  methods: {
    hideEventDeleteForm() {
      const vm = this;
      vm.$notificationManager.emit('hide-delete-event-form', vm.event);
    },
    deleteEventPressed: _.throttle(function () {
      const vm = this;
      // If this is a duplicate request, just return
      if (vm.loading === true) {
        return;
      }
      vm.loading = true;

      let url = vm.$apiService.eventUrl(vm.event.id);
      const deleteRecurring = vm.recurringPick !== 'single';
      if (vm.recurringPick === 'all') {
        // delete all recurring events
        url = vm.$apiService.deleteEventRecurringUrl(vm.event.id);
      } else if (vm.recurringPick === 'future') {
        // delete this event and all following occurrences
        url = vm.$apiService.deleteEventFutureRecurringUrl(vm.event.id);
      }

      axios.delete(url)
        .then((response) => {
          vm.loading = false;

          vm.$notificationManager.emit('show-toast', vm.isAvailability ? 'Availability removed' : 'Event deleted', true);
          vm.$notificationManager.emit('event-deleted', vm.event, deleteRecurring, vm.recurringPick);
        })
        .catch((error) => {
          vm.loading = false;
          vm.errorMessage = vm.parseErrorResponse(error);
          vm.error = true;
        });
    }, 500),
  },
};
</script>
